import React from 'react';
import { Routes, Route } from 'react-router-dom'; // No BrowserRouter here!

import Home from '../pages/Home/Home';
import MainLayout from '../Layouts/MainLayout';
import AuthLayout from '../Layouts/AuthLayout';
import Review from '../pages/Review/Review';
import ContactUs from '../components/MainPages/ContactUs/ContactUs';
import About from '../components/MainPages/About/About';
import Service from '../components/MainPages/Service/Service';
import Internship from '../components/MainPages/Internship/Internship';
import Login from "../examPortal/comPages/login/login";

function AppRoutes() {
    return (
        <Routes>

            {/* Main Website Layout */}
            <Route element={<MainLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/review" element={<Review />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route path="/aboutus" element={<About />} />
                <Route path="/service" element={<Service />} />
                <Route path="/internship" element={<Internship />} />
            </Route>

            {/* Auth Layout (no Navbar/Footer) */}
            <Route element={<AuthLayout />}>
                <Route path="/login" element={<Login />} />
            </Route>

        </Routes>
    );
}

export default AppRoutes;
